






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import _get from 'lodash/get';
import { mixins } from 'vue-class-component';
import { IMenu, IMenuType } from '@/types/menu';
import { MenuMixins } from './MenuMixins';
import TypeSelector from './TypeSelector.vue';
import TemplateSelector from './TemplateSelector.vue';

@Component({
  components: { TypeSelector, TemplateSelector },
})
export default class EditItem extends mixins(MenuMixins) {
  @Prop({
    type: Object,
    default: () => ({
      keys: [],
      name: '',
      pattern: '',
      subs: [],
      type: 'html',
    }),
  })
  value: IMenu | undefined;

  @Prop({
    type: Array,
    default: () => ['html', 'list', 'link', 'vain'],
  })
  typeList;

  @Prop({
    type: [Boolean, String],
  })
  unselectableType;

  @Prop({
    type: String,
    default: '确定',
  })
  positiveButtonText;

  @Prop({
    type: String,
    default: '取消',
  })
  negativeButtonText;

  @Prop({
    type: [Boolean, String],
  })
  disablePattern;

  @Prop({
    type: [Boolean, String],
  })
  hasBannerName;

  @Prop({ type: [Boolean, String] })
  isSpecial;

  get name() {
    return _get(this.value, 'name');
  }

  private update(eventName, payload) {
    this.$emit(eventName, payload);
    this.$forceUpdate();
  }
}
